import { defineStore } from "pinia";

export const useLoadingStore = defineStore("loading", {
  state: () => ({
    pageIsLoading: false,
    background: false,
  }),
  actions: {
    show(bg = false) {
      this.pageIsLoading = true;
      this.background = bg;
    },
    hide() {
      this.pageIsLoading = false;
      this.background = false;
    },
  },
});
